import { Room, Rooms } from '@/studio/rooms/store/types';

export interface State {
  booths: Booths;
  isLoading: boolean;
}

export interface Booth {
  booth_type: BoothType;
  created_at: string;
  cta: string;
  deleted: object;
  demo_request_button_text: object;
  demo_request_enabled: boolean;
  demo_request_message: object;
  demo_request_title: object;
  description: string;
  discussion_group: string[];
  discussion_group_objects: Room[];
  discussionGroupObjects?: Rooms;
  event: string;
  hero_asset: string;
  hero_asset_type: string;
  id: string;
  logo: string;
  mmid: string;
  moderator: number[];
  name: string;
  poster: string;
  rank: number;
  resources: Resource[];
  sponsor_link: string;
  tags: number[];
  tier: TierType;
  updated_at: string;
  vcapture_url: object;
  image?: string;
}

export type Booths = {
  [id: string]: Booth;
};

export const enum BoothType {
  primary = 'Primary',
  secondary = 'Secondary'
}

export const enum TierType {
  tier1 = 'TIER1',
  tier2 = 'TIER2',
  tier3 = 'TIER3'
}

export type BoothsByTier = {
  boothTierText: string;
  boothTierType: TierType;
  booths: Booth[];
};

export interface Payload {
  booth_type: BoothType;
  id: string;
  name: string;
  tier: string;
  tags: string[];
  description: string;
  hero_asset_type: string;
  hero_asset: string;
  logo: string;
  sponsor_link: string;
  demo_request_enabled: boolean;
  demo_request_button_text: string;
  demo_request_title: string;
  demo_request_message: string;
  email?: string;
  event: string;
  key_or_url: string;
}

export interface Resource {
  content_object: string;
  content_type: string;
  created_at: string;
  event: string;
  id: string;
  key_or_url: string;
  name: string;
  object_id: string;
  s3hosted: boolean;
  updated_at: string;
}

export interface ResourcePayload {
  name: string;
  key_or_url: string;
  content_type: string;
  s3hosted: boolean;
  event?: string;
  object_id: string;
}

export interface updateResourcePayload {
  body: {
    key_or_url: string;
    name: string;
    object_id: string;
  };
  id: string;
}

export interface RoomData {
  roomName: string;
  roomCapacity: number;
  imageUrl: string;
  tags: string;
  selectedRoomIndex: number;
}

export interface ResourceData {
  docName: string;
  docLink: string;
  selectedDocIndex: number;
}
